import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

function ProductDescriptionList({ list }) {
  return (
    <ProductBottom>
      {list?.map((item, index) => (
        <ProductBox key={index}>
          <h2
            style={{
              background: `url(${item.img}) left center no-repeat`,
              paddingLeft: '60px',
              backgroundSize: '50px',
            }}
          >
            {item.title}
          </h2>
          <p>{item.content}</p>
        </ProductBox>
      ))}
    </ProductBottom>
  );
}

const ProductBottom = styled(Box)({
  backgroundColor: '#f5f5f5',
  padding: '60px 10%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});
const ProductBox = styled(Card)({
  padding: '60px',
  '& p': {
    marginTop: '20px',
    fontSize: '1.3rem',
  },
  width: '49%',
  marginBottom: '40px',
});

export default ProductDescriptionList;
